import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { company } from '../../data/company';

const LOGO_URL = 'https://i.ibb.co/Kx1MQFY0/ltc-construction-logo-removebg-preview.png';

const quickLinks = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/services' },
  { name: 'About Us', path: '/about' },
  { name: 'Equipment', path: '/equipment' },
  { name: 'Contact', path: '/contact' },
];

const services = [
  { name: 'General Construction', path: '/services#general-building' },
  { name: 'Structural Concrete', path: '/services#structural-concrete' },
  { name: 'Steel Fabrication', path: '/services#steel-fabrication' },
  { name: 'Renovations', path: '/services#renovations' },
  { name: 'Civil Infrastructure', path: '/services#civil-infrastructure' },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-charcoal-900 text-white">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img
                src={LOGO_URL}
                alt="Lifetime Creation Construction"
                className="h-16 w-32"
              />
              
            </Link>
            <p className="text-charcoal-400 text-sm leading-relaxed mb-6">
              {company.mission}
            </p>
            <p className="text-charcoal-500 text-sm">
              Est. {company.foundedYear}
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-charcoal-400 hover:text-primary-400 transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-charcoal-400 hover:text-primary-400 transition-colors text-sm"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary-500 flex-shrink-0 mt-0.5" />
                <span className="text-charcoal-400 text-sm">
                  {company.coverage}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-primary-500 flex-shrink-0" />
                <a
                  href="tel:+1876XXXXXXX"
                  className="text-charcoal-400 hover:text-primary-400 transition-colors text-sm"
                >
                  Contact Us
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary-500 flex-shrink-0" />
                <a
                  href="mailto:info@lifetimecreation.com"
                  className="text-charcoal-400 hover:text-primary-400 transition-colors text-sm"
                >
                  info@lifetimecreation.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-charcoal-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-charcoal-500 text-sm text-center md:text-left">
              &copy; {currentYear} {company.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-2 text-charcoal-500 text-sm">
              <span className="px-2 py-1 bg-charcoal-800 rounded text-xs font-medium">
                {company.safetyStandard}
              </span>
              <span>Compliant</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
